export const prosMessages = {
  catalog: ['Каталог', 'Catalog', 'Kataloq'],
  favorites: ['Избранное', 'Favorites', 'Seçilmişlər'],
  myListings: ['Мои объявления', 'My listings', 'Elanlarım'],
  newListing: ['Создать объявление', 'Create listing', 'Elan yarat'],
  editListing: ['Редактировать объявление', 'Edit listing', 'Elanı redaktə et'],
  bookings: [
    'Сделки и записи',
    'Deals and bookings',
    'Sövdələşmələr və rezervasiyalar',
  ],
  onlineBooking: ['Онлайн-запись', 'Online booking', 'Onlayn rezervasiya'],
  category: ['Категория', 'Category', 'Kateqoriya'],
  subcategory: ['Подкатегория', 'Subcategory', 'Alt kateqoriya'],
  city: ['Город', 'City', 'Şəhər'],
  priceMin: ['Цена от', 'Minimum price', 'Minimum qiymət'],
  priceMax: ['Цена до', 'Maximum price', 'Maksimum qiymət'],
  priceAsc: ['Сначала дешевле', 'Lowest price first', 'Əvvəl ucuz'],
  priceDesc: ['Сначала дороже', 'Highest price first', 'Əvvəl baha'],
  fromPrice: ['от {{price}} K', 'from {{price}} K', '{{price}} K-dan'],
  reviews: ['Отзывы', 'Reviews', 'Rəylər'],
  book: ['Записаться', 'Book now', 'Rezerv et'],
  services: ['Услуги', 'Services', 'Xidmətlər'],
  specialist: ['Мастер', 'Professional', 'Mütəxəssis'],
  description: ['Описание', 'Description', 'Təsvir'],
  active: ['Активные', 'Active', 'Aktiv'],
  finished: ['Завершённые', 'Finished', 'Tamamlanmış'],
  statusACTIVE: ['Опубликовано', 'Published', 'Dərc edilib'],
  statusON_MODERATION: [
    'На модерации · до 24 часов',
    'Under review · up to 24 hours',
    'Yoxlanılır · 24 saata qədər',
  ],
  statusREJECTED: ['Нужно исправить', 'Changes needed', 'Düzəliş tələb olunur'],
  statusBLOCKED: ['Заблокировано', 'Blocked', 'Bloklanıb'],
  statusARCHIVED: ['Снято с публикации', 'Unpublished', 'Dərcdən çıxarılıb'],
  statusDRAFT: ['Черновик', 'Draft', 'Qaralama'],
  unpublish: ['Снять с публикации', 'Unpublish', 'Dərcdən çıxar'],
  republish: ['Опубликовать снова', 'Publish again', 'Yenidən dərc et'],
  unpublishConfirm: [
    'Снять объявление? Модерация будет прервана.',
    'Unpublish this listing? Moderation will stop.',
    'Elan dərcdən çıxarılsın? Moderasiya dayandırılacaq.',
  ],
  basic: ['Основное', 'Basics', 'Əsas'],
  about: ['О себе', 'About', 'Haqqında'],
  priceList: ['Прайс', 'Price list', 'Qiymətlər'],
  title: ['Название', 'Title', 'Başlıq'],
  audience: ['Аудитория', 'Audience', 'Auditoriya'],
  CHILDREN: ['Дети', 'Children', 'Uşaqlar'],
  WOMEN: ['Женщины', 'Women', 'Qadınlar'],
  MEN: ['Мужчины', 'Men', 'Kişilər'],
  photos: ['Фото', 'Photos', 'Fotolar'],
  photoRules: [
    '1–9 фото JPEG, PNG или WebP. Перетащите для изменения порядка.',
    '1–9 JPEG, PNG or WebP photos. Drag to reorder.',
    '1–9 JPEG, PNG və ya WebP foto. Sıralamaq üçün sürüşdürün.',
  ],
  addService: ['Добавить услугу', 'Add service', 'Xidmət əlavə et'],
  duration: ['Длительность, мин', 'Duration, min', 'Müddət, dəq'],
  remote: ['Дистанционно', 'Remote', 'Məsafədən'],
  FIXED: ['За услугу', 'Per service', 'Xidmətə görə'],
  FROM: ['От', 'From', 'Başlanğıc'],
  HOURLY: ['В час', 'Per hour', 'Saatlıq'],
  unit: ['Единица', 'Unit', 'Vahid'],
  square: ['м²', 'm²', 'm²'],
  visit: ['Выезд', 'Visit', 'Səfər'],
  perDay: ['День', 'Day', 'Gün'],
  cubic: ['м³', 'm³', 'm³'],
  month: ['Месяц', 'Month', 'Ay'],
  publish: ['Опубликовать', 'Publish', 'Dərc et'],
  publishing: [
    'Публикация · шаг {{step}} из 6',
    'Publishing · step {{step}} of 6',
    'Dərc edilir · addım {{step}} / 6',
  ],
  publishError: [
    'Не удалось выполнить шаг {{step}}. Прогресс сохранён.',
    'Step {{step}} failed. Progress has been saved.',
    '{{step}} addımı alınmadı. Gedişat saxlanılıb.',
  ],
  moderationWarning: [
    'Изменение опубликованного объявления отправит его на повторную модерацию.',
    'Editing a published listing sends it for moderation again.',
    'Dərc edilmiş elanın dəyişdirilməsi onu yenidən moderasiyaya göndərəcək.',
  ],
  draftSaved: [
    'Черновик сохранён на 30 дней',
    'Draft saved for 30 days',
    'Qaralama 30 gün saxlanılıb',
  ],
  drafts: ['Мои черновики', 'My drafts', 'Qaralamalarım'],
  draftExpires: [
    'Удалится через {{days}} дн.',
    'Expires in {{days}} days',
    '{{days}} gün sonra silinəcək',
  ],
  saveDraft: ['Сохранить черновик', 'Save draft', 'Qaralamanı saxla'],
  finishLater: ['Завершить позже', 'Finish later', 'Sonra tamamla'],
  leaveForm: [
    'Сохранить изменения и завершить позже?',
    'Save changes and finish later?',
    'Dəyişikliklər saxlanılsın və sonra tamamlansın?',
  ],
  lostPhotos: [
    'Файлы фото недоступны. Выберите их ещё раз.',
    'Photo files are unavailable. Select them again.',
    'Foto faylları əlçatmazdır. Yenidən seçin.',
  ],
  requiredFields: [
    'Заполните обязательные поля',
    'Complete required fields',
    'Məcburi sahələri doldurun',
  ],
  schedule: ['Расписание', 'Schedule', 'Cədvəl'],
  workday: ['Рабочий день', 'Working day', 'İş günü'],
  dayOff: ['Выходной', 'Day off', 'İstirahət'],
  startTime: ['Начало', 'Start', 'Başlanğıc'],
  endTime: ['Конец', 'End', 'Son'],
  scheduleHint: [
    'Недельное расписание для всех объявлений. Слот — 60 минут.',
    'Weekly schedule for all listings. Each slot is 60 minutes.',
    'Bütün elanlar üçün həftəlik cədvəl. Hər vaxt aralığı 60 dəqiqədir.',
  ],
  setupSchedule: [
    'Настроить онлайн-запись',
    'Set up online booking',
    'Onlayn rezervasiyanı qur',
  ],
  onlinePromo: [
    'Попробуйте онлайн-запись бесплатно',
    'Try online booking for free',
    'Onlayn rezervasiyanı pulsuz sınayın',
  ],
  calendar: ['Календарь', 'Calendar', 'Təqvim'],
  dateTime: ['Дата и время', 'Date and time', 'Tarix və vaxt'],
  selectSlot: ['Выберите дату и время', 'Choose date and time', 'Tarix və vaxt seçin'],
  slotTaken: [
    'Слот уже занят. Выберите другое время.',
    'This slot is taken. Choose another time.',
    'Bu vaxt tutulub. Başqa vaxt seçin.',
  ],
  booked: ['Вы записаны', 'Booking confirmed', 'Rezervasiya təsdiqləndi'],
  partialBooking: [
    'Создано {{count}} записей. Остальные ещё не отправлены.',
    '{{count}} bookings created. The rest have not been sent.',
    '{{count}} rezervasiya yaradılıb. Qalanları göndərilməyib.',
  ],
  kelvin: ['Kelvin', 'Kelvin', 'Kelvin'],
  cardPayment: ['Карта', 'Card', 'Kart'],
  mir: ['МИР', 'MIR', 'MIR'],
  safeDeal: ['Безопасная сделка', 'Protected payment', 'Təhlükəsiz ödəniş'],
  escrowHint: [
    'Предоплата замораживается до подтверждения услуги.',
    'Prepayment is held until the service is confirmed.',
    'Öncədən ödəniş xidmət təsdiqlənənədək saxlanılır.',
  ],
  total: ['Итого', 'Total', 'Cəmi'],
  payment: ['Оплата', 'Payment', 'Ödəniş'],
  clientRole: ['Я — клиент', 'I am the client', 'Mən müştəriyəm'],
  specialistRole: ['Я — профи', 'I am the professional', 'Mən mütəxəssisəm'],
  bookingCONFIRMED: ['Подтверждена', 'Confirmed', 'Təsdiqlənib'],
  bookingCOMPLETED: ['Завершена', 'Completed', 'Tamamlanıb'],
  bookingCANCELLED: ['Отменена', 'Cancelled', 'Ləğv edilib'],
  bookingDISPUTED: ['Спор', 'Disputed', 'Mübahisə'],
  escrowNONE: ['Без предоплаты', 'No prepayment', 'Öncədən ödənişsiz'],
  escrowHELD: ['Предоплата заморожена', 'Prepayment held', 'Öncədən ödəniş saxlanılıb'],
  escrowRELEASED: ['Оплата переведена', 'Payment released', 'Ödəniş köçürülüb'],
  escrowREFUNDED: [
    'Предоплата возвращена',
    'Prepayment refunded',
    'Öncədən ödəniş qaytarılıb',
  ],
  completeService: [
    'Подтвердить оказание услуги',
    'Confirm service completion',
    'Xidmətin tamamlanmasını təsdiqlə',
  ],
  cancelBooking: [
    'Отменить запись?',
    'Cancel this booking?',
    'Rezervasiya ləğv edilsin?',
  ],
  review: ['Оставить отзыв', 'Write a review', 'Rəy yaz'],
  reviewNew: ['Новые', 'Newest', 'Ən yeni'],
  reviewOld: ['Старые', 'Oldest', 'Ən köhnə'],
  reviewHigh: ['Высокая оценка', 'Highest rating', 'Ən yüksək qiymət'],
  reviewLow: ['Низкая оценка', 'Lowest rating', 'Ən aşağı qiymət'],
  reviewRules: [
    'От 1 до 500 символов, без эмодзи',
    '1–500 characters, no emoji',
    '1–500 simvol, emojisiz',
  ],
  rating: ['Оценка', 'Rating', 'Qiymət'],
  complain: ['Пожаловаться', 'Report', 'Şikayət et'],
  deleteConfirm: [
    'Удалить? Это действие нельзя отменить.',
    'Delete? This cannot be undone.',
    'Silinsin? Bunu geri qaytarmaq olmaz.',
  ],
} as const;
